import Hero from "@/components/sections/Hero";
import TrustStrip from "@/components/sections/TrustStrip";
import AvailableNow from "@/components/sections/AvailableNow";
import EditorialMarquee from "@/components/sections/EditorialMarquee";
import Principles from "@/components/sections/Principles";
import Professionals from "@/components/sections/Professionals";
import StudioNote from "@/components/sections/StudioNote";

export default function Home() {
  return (
    <>
      <Hero />
      <TrustStrip />
      <AvailableNow />
      <EditorialMarquee />
      <Principles />
      <Professionals />
      <StudioNote />
    </>
  );
}
